export const industriesKeys = {
  list: () => ['industriesList'] as const,
}
